function ThirdPillarPayment(config) {
  this.init = function () {
    return {}
  }

  this.done = function () {
    $('#third-pillar-payment-amount').on('input', onAmountChange)
    $('#third-pillar-payment-form').on('submit', continueToPayment)
  }

  function onAmountChange(event) {
    const value  = event.target.value
    hideBanklink()
    hideWarning()

    if (value > 0) {
      $('#third-pillar-payment-continue').removeAttr('disabled')
    } else {
      $('#third-pillar-payment-continue').attr('disabled', true)
    }
  }

  function showWarning() {
    $('#third-pillar-warning').removeClass('d-none')
  }

  function hideWarning() {
    $('#third-pillar-warning').addClass('d-none')
  }

  function continueToPayment(event) {
    event.preventDefault()
    const form = event.target

    const amount = form['third-pillar-payment-amount'].value
    if (amount > 500) {
      showWarning()
    }

    updateBanklinkPacket(amount)
    $('#third-pillar-payment-continue').attr('disabled', true)
  }

  function updateBanklinkPacket(amount) {
    Fetch.post('/banklink/payment', {amount: amount})
      .then(function (result) {
        if (!result['allowed']) {
          hideBanklink();
        }
        else {
          showBanklink(result);
        }
      }, hideBanklink);
  }

  function hideBanklink() {
    $('#third-pillar-payment-methods').hide();
  }

  function showBanklink(result) {
    const formattedAmount = Intl.NumberFormat('et-EE', {style: 'currency', currency: 'EUR'}).format(result.amount)
    document.querySelector("#third-pillar-payment-confirmation").textContent = formattedAmount
    document.querySelector("#pay-with-swedbank").addEventListener('click', () => sendBankLink(result.swedbank))
    document.querySelector("#pay-with-seb").addEventListener('click', () => sendBankLink(result.seb))
    document.querySelector("#pay-with-lhv").addEventListener('click', () => sendBankLink(result.lhv))
    document.querySelector("#pay-with-luminor").addEventListener('click', () => sendLuminorBankLink(result.luminor))
    $('#third-pillar-payment-methods').show();
  }

  function sendBankLink(url) {
    const form = document.createElement('form')
    form.action = url
    form.method = 'post'
    form.classList.add('d-none')
    document.body.append(form)
    form.submit()
  }

  function sendLuminorBankLink(luminor) {
    const form = document.createElement('form')
    form.action = config.banklinkPaymentUrl
    form.method = 'post'
    form.classList.add('d-none')
    for (const key in luminor) {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", key);
      input.setAttribute("value", luminor[key]);
      form.appendChild(input);
    }

    document.body.append(form)
    form.submit()
  }
}